import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCounterUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2018_41362)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.3999 6.60039C11.8358 6.60039 12.9999 5.43633 12.9999 4.00039C12.9999 2.56445 11.8358 1.40039 10.3999 1.40039M10.5999 9.40039H10.6999C12.8538 9.40039 14.5999 11.1465 14.5999 13.3004C14.5999 14.0184 14.0179 14.6004 13.2999 14.6004H11.9999M8.1999 4.00039C8.1999 5.43633 7.03584 6.60039 5.5999 6.60039C4.16396 6.60039 2.9999 5.43633 2.9999 4.00039C2.9999 2.56445 4.16396 1.40039 5.5999 1.40039C7.03584 1.40039 8.1999 2.56445 8.1999 4.00039ZM2.6999 14.6004H8.4999C9.21787 14.6004 9.7999 14.0184 9.7999 13.3004C9.7999 11.1465 8.05381 9.40039 5.8999 9.40039H5.2999C3.14599 9.40039 1.3999 11.1465 1.3999 13.3004C1.3999 14.0184 1.98193 14.6004 2.6999 14.6004Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2018_41362",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCounterUsers);
export { ForwardRef as ReactComponent };
